module.exports = __webpack_public_path__ + "img/total-quiz.7be84a17.svg";